import React, { useEffect, useState } from 'react';
import { Headercomponent } from '../components/headercomponent';
import dashboard_photo from '../images/dashboard_photo.jpg';
// import threat_photo from '../images/threat_photo.jpg';
import data_nodes_graphic from '../images/data_nodes_graphic.png';
// import threat_platform from '../images/Threat platform examples_small.png';
// import alerts_photo from '../images/alerts_photo.jpg';
import { GlobeHero, globeHero } from '../components/globeComponent';
// import { ThreatCard } from '../components/threatExamplecomponent';
// import { ReactComponent as OsintWorkFlow } from '../images/osint_workflow.svg';
import NodeBackground from '../components/nodeBackground'
import DemoModal from '../components/demoModal'
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';


Modal.setAppElement('#root');

// The world layers are from: nwo.gsfc.nasa.gov

// const NodeBackground = () => {
//   const nodes = Array.from({ length: 20 }, (_, i) => (
//     <div key={i} className="node" style={{
//       top: `${Math.random() * 100}%`,
//       left: `${Math.random() * 100}%`,
//       animationDelay: `${Math.random() * 5}s`
//     }}></div>
//   ));
//   return <div className="hero-background">{nodes}</div>
// };

export const Product = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [imageModal, setImageModal] = useState(null);
  const [activeWorkflowCard, setActiveWorkflowCard] = useState('collection');

  const handleModal = () => setModalIsOpen(!modalIsOpen);
  const demoVideoUrl = "https://www.youtube.com/watch?v=s-M5rmdCSgk";
  const demoVideoThumbnail = "https://img.youtube.com/vi/s-M5rmdCSgk/hqdefault.jpg";

  useEffect(() => {
    const cards = document.querySelectorAll('.workflow-card');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveWorkflowCard(entry.target.dataset.workflow);
          }
        });
      },
      {
        root: null,
        threshold: 0.45,
        rootMargin: '-20% 0px -35% 0px',
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Headercomponent />

      <div className="container">
        <div className="hero">
          <NodeBackground />
          <div className="hero-content">
            <h1>Find the threats your analysts would otherwise miss.</h1>
            <p>WeatherVane continuously monitors comments, forums, news, and emerging online conversations to surface credible threats before they become operational concerns.</p>
            {/* <p>Detect, prioritize, and act on emerging threats before they impact your executives or assets.</p> */}
            <button className="cta-button" onClick={handleModal}>Schedule a Demo</button>
          </div>
          <div className="hero-diagram">
            <GlobeHero />
          </div>
        </div>
        <section className="platform-overview">
          <h1>Built by an Intelligence Analyst for Protective Intelligence</h1>
          <p>Our platform was founded by a former law enforcement officer and OSINT analyst with nine years of experience supporting investigations, executive protection, and intelligence operations. Data from public sources can often be too overwhelming for OSINT analysts or protective intelligence teams. Our software helps save countless hours of collection and manual analysis so that you can focus on answering your intelligence questions to build meaninful products.</p>

        </section>
        <section className="platform-overview analyst-workflow-section">
          <h1>Built around the analyst workflow</h1>
          <div
            className="workflow-graphic-shell"
            onClick={() => setImageModal("/intelligence_cycle_saas.png")}
          >
            <img
              src="/intelligence_cycle_saas.png"
              alt="Intelligence cycle showing collection, analysis, prioritization, investigation, and reporting"
              className="workflow-graphic"
            />
          </div>

          <div className="workflow-divider">
            <div className="workflow-divider-line"></div>

            {/* <div className="workflow-divider-label">
    Analyst Workflow
  </div> */}

            <div className="workflow-divider-line"></div>
          </div>

          <div className="overview-cards workflow-cards">

            <div
              className={`overview-feature workflow-card ${activeWorkflowCard === 'collection' ? 'active' : ''}`}
              data-workflow="collection"
            >
              <div
                className="feature-graphic clickable-graphic"
                onClick={() => setImageModal("/Weathervane Priority Filter.png")}
              >
                <img
                  src="/Weathervane Priority Filter.png"
                  alt="Continuous Collection Workflow"
                  className="service-preview-image"
                />
              </div>
              <div className="feature-text">
                <h3>Continuous Collection</h3>
                <p>Protect the people, organizations, and locations that matter most by continuously monitoring online activity across news, forums, comment sections, and other publicly available sources. Instead of manually searching dozens of platforms throughout the day, your team receives a centralized collection of relevant information as it emerges, ensuring important conversations are never overlooked.</p>
              </div>
            </div>
            <div
              className={`overview-feature workflow-card reverse ${activeWorkflowCard === 'analyze' ? 'active' : ''}`}
              data-workflow="analyze"
            >
              <div
                className="feature-graphic clickable-graphic"
                onClick={() => setImageModal("/Weathervane_LLM_filter.png")}
              >
                <img
                  src="/Weathervane_LLM_filter.png"
                  alt="Language Model Filter"
                  className="service-preview-image"
                />
              </div>
              <div className="feature-text">
                <h3>Analyze</h3>
                <p>Every collected item is processed using advanced language analysis to identify context, intent, and relevance rather than relying solely on keyword matches. By evaluating the language surrounding an asset, the platform helps surface meaningful activity while reducing the noise that often overwhelms intelligence teams.</p>
              </div>
            </div>
            <div
              className={`overview-feature workflow-card ${activeWorkflowCard === 'prioritize' ? 'active' : ''}`}
              data-workflow="prioritize"
            >
              <div
                className="feature-graphic clickable-graphic"
                onClick={() => setImageModal("/Prioritize_Review.png")}
              >
                <img
                  src="/Prioritize_Review.png"
                  alt="Prioritize the output"
                  className="service-preview-image"
                />
              </div>
              <div className="feature-text">
                <h3>Prioritize</h3>
                <p>Not every mention requires attention. WeatherVane automatically prioritizes content based on threat indicators, language patterns, and contextual relevance, allowing analysts to focus on the information most likely to impact operations. This reduces manual review time while helping ensure significant developments receive immediate attention.</p>
              </div>
            </div>
            <div
              className={`overview-feature workflow-card reverse ${activeWorkflowCard === 'investigate' ? 'active' : ''}`}
              data-workflow="investigate"
            >
              <div
                className="feature-graphic clickable-graphic"
                onClick={() => setImageModal("/analyst_investigation.png")}
              >
                <img
                  src="/analyst_investigation.png"
                  alt="Analyst Investigaes"
                  className="service-preview-image"
                />
              </div>
              <div className="feature-text">
                <h3>Investigate</h3>
                <p>Technology identifies where to look, but analysts determine what it means. WeatherVane provides direct access to original sources, related discussions, user profiles, and supporting context so investigators can pivot through available information, validate findings, and develop their own assessments. The platform is designed to accelerate investigative workflows while leaving analytical judgment in the hands of the professional.</p>
              </div>
            </div>
            <div
              className={`overview-feature workflow-card ${activeWorkflowCard === 'report' ? 'active' : ''}`}
              data-workflow="report"
            >
              <div
                className="feature-graphic clickable-graphic"
                onClick={() => setImageModal("/analyst_report.png")}
              >
                <img
                  src="/analyst_report.png"
                  alt="Analyst Investigaes"
                  className="service-preview-image"
                />
              </div>
              <div className="feature-text">
                <h3>Report</h3>
                <p>This is where your analysts can shine! Transform investigative findings into intelligence products that support operational decision making. WeatherVane provides dashboards, charts, metrics, timelines, and visualizations that analysts can use to communicate threat trends, support executive briefings, and produce professional intelligence reports. Rather than replacing the analyst's expertise, the platform provides the data and visual evidence needed to create clear, defensible assessments.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="demo-video-section">
          <div className="demo-video-card">
            <div className="demo-video-copy">
              <span className="section-kicker">Product Demo</span>
              <h1>See WeatherVane in Action</h1>
              <p>
                Watch a quick demo on how to use the platform to find relevant results quickly.
              </p>
              {/* <p className="demo-video-note">
                No marketing slides. Just the platform and analyst workflow.
              </p> */}
            </div>

            <a
              href={demoVideoUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="demo-video-thumbnail"
              aria-label="Watch WeatherVane product demo on YouTube"
            >
              <img
                src={demoVideoThumbnail}
                alt="WeatherVane product demo thumbnail"
              />
              <div className="demo-play-overlay">
                <span className="demo-play-button">▶</span>
              </div>
            </a>
          </div>
        </section>

        {/* <section className="platform-overview">
          <div className="capability-statement">
            <h1>Extend Your Executive Protection Capability</h1>

            <p>
              Weathervane Intel functions as a protective intelligence extension for executive protection teams,
              family offices, and corporate security programs. It provides continuous OSINT-driven awareness and
              event-specific intelligence support when risk, travel, or visibility increases.
            </p>

            <p>
              Use it as an always-on intelligence layer for ongoing monitoring, or as a focused support capability
              for high-consequence events, travel, or executive exposure scenarios.
            </p>

            <Link to="/threat-assessment" className="capability-link card-link">
              <div className="card-link-content">
                <div className="card-left">
                  <h4>Explore Protective Intelligence Outputs</h4>
                  <p>
                    View example briefings and reports used to support executive protection teams,
                    threat analysts, and operational security decisions.
                  </p>
                </div>
                <div className="card-right">
                  <span className="arrow">→</span>
                </div>
              </div>
            </Link>
          </div>
        </section> */}


        {/* How it Works */}
        <section className="how-it-works">
          <h2>How It Works</h2>
          <ol>
            <li>Define your assets and generate tailored search criteria in a few steps.</li>
            <li>Review automatically prioritized threats for faster, smarter decision-making.</li>
            <li>Take immediate action with real-time insights delivered to your team.</li>
          </ol>
        </section>

        {/* Call to Action */}
        <section className="cta-section">
          <h2>Stay Ahead of Emerging Threats</h2>
          <p>Protect your people, assets, and reputation by detecting risks before they become physical. Gain real-time visibility into the incidents that matter most.</p>
          <button className="cta-button" onClick={handleModal}>Schedule a Demo</button>
        </section>

        <Modal
          isOpen={!!imageModal}
          onRequestClose={() => setImageModal(null)}
          contentLabel="Workflow Preview"
          className="image-modal-content"
          overlayClassName="image-modal-overlay"
        >
          <button className="image-modal-close" onClick={() => setImageModal(null)}>
            ×
          </button>

          <div className="image-modal-body">
            {imageModal && (
              <img
                src={imageModal}
                alt="Expanded graphic"
                className="modal-image"
              />
            )}
          </div>
        </Modal>
        <DemoModal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)} />
      </div>
      <Footer />
    </>
  );
};